// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "chunk-common" + "." + "3daba8fe" + ".js";
};